export const EthiopianCross = ({ className = "", ...rest }) => (
  <img
    src="/church-logo.png"
    alt="St. Michael Ethiopian Orthodox Church emblem"
    className={`object-contain ${className}`}
    {...rest}
  />
);

export default EthiopianCross;
